import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  closed: {
    display: 'inline-block',
    backgroundColor: theme.palette.greyScale.light,
    borderRadius: '8px',
    padding: '4px 6px',
    color: theme.palette.greyScale.dark,
  },
  live: {
    display: 'inline-block',
    backgroundColor: theme.palette.positive.superlight,
    borderRadius: '8px',
    padding: '4px 6px',
    color: theme.palette.positive.main,
  },
}));

interface Props {
  isClosed: boolean;
}

const defaultProps = {};

const Status = ({ isClosed }: Props) => {
  const classes = useStyles();
  return (
    <div className={isClosed ? classes.closed : classes.live}>
      {isClosed ? 'closed' : 'live'}
    </div>
  );
};

Status.defaultProps = (defaultProps as unknown) as Partial<Props>;

export default Status;
